/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '../shared/assets/css/inline-edit-common.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/forms';
import * as i3 from '@angular/common';
import * as i4 from '../../../../../../../../src/app/components/shared/inline-edit/components/input-text/input-text.component';
const styles_InputTextComponent:any[] = [i0.styles];
export const RenderType_InputTextComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_InputTextComponent,data:{}});
function View_InputTextComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'p',[['class',
      'alert alert-danger flat-elm font-14 m-bottom-10']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n	'])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),1,'strong',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),0,'i',[['aria-hidden','true'],['class','fa fa-exclamation-circle']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),[' ','\n']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.vError;
    _ck(_v,4,0,currVal_0);
  });
}
function View_InputTextComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),17,'div',[['class',
      'input-group']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n	'])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          5,'input',[['class','form-control'],['type','text']],[[8,'placeholder',0],
              [2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
                  (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
              [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],[[(null as any),
              'ngModelChange'],[(null as any),'input'],[(null as any),'blur'],[(null as any),
              'compositionstart'],[(null as any),'compositionend']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,3)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,3).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,3)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,3)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_4:any = ((<any>(_co.localData = $event)) !== false);
              ad = (pd_4 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i2.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i2.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i2.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i2.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i2.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i2.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i2.NgControl,
          (null as any),[i2.NgModel]),i1.ɵdid(16384,(null as any),0,i2.NgControlStatus,
          [i2.NgControl],(null as any),(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n	'])),(_l()(),i1.ɵeld(0,(null as any),(null as any),7,'span',[['class',
          'input-group-addon flat-elm']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n		'])),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),1,'span',[['class','text-green cp text-bold m-right-10']],
              (null as any),[[(null as any),'click']],(_v,en,$event) => {
                var ad:boolean = true;
                var _co:any = _v.component;
                if (('click' === en)) {
                  const pd_0:any = ((<any>_co.onSaveClick()) !== false);
                  ad = (pd_0 && ad);
                }
                return ad;
              },(null as any),(null as any))),(_l()(),i1.ɵted((null as any),['Save'])),
      (_l()(),i1.ɵted((null as any),['\n		'])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          1,'span',[['class','text-red cp text-bold']],(null as any),[[(null as any),
              'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.onCancelClick()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵted((null as any),['Cancel'])),
      (_l()(),i1.ɵted((null as any),['\n	'])),(_l()(),i1.ɵted((null as any),['\n']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_8:any = _co.localData;
        _ck(_v,5,0,currVal_8);
      },(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.placeholder;
        const currVal_1:any = i1.ɵnov(_v,7).ngClassUntouched;
        const currVal_2:any = i1.ɵnov(_v,7).ngClassTouched;
        const currVal_3:any = i1.ɵnov(_v,7).ngClassPristine;
        const currVal_4:any = i1.ɵnov(_v,7).ngClassDirty;
        const currVal_5:any = i1.ɵnov(_v,7).ngClassValid;
        const currVal_6:any = i1.ɵnov(_v,7).ngClassInvalid;
        const currVal_7:any = i1.ɵnov(_v,7).ngClassPending;
        _ck(_v,2,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
            currVal_7);
      });
}
export function View_InputTextComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_InputTextComponent_1)),i1.ɵdid(16384,(null as any),0,i3.NgIf,[i1.ViewContainerRef,
      i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),
      ['\n'])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_InputTextComponent_2)),i1.ɵdid(16384,(null as any),0,i3.NgIf,[i1.ViewContainerRef,
      i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any))],(_ck,_v) => {
    var _co:i4.InputTextComponent = _v.component;
    const currVal_0:any = _co.vError;
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = (_co.state === 'active');
    _ck(_v,4,0,currVal_1);
  },(null as any));
}
export function View_InputTextComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'inline-edit-input-text',
      ([] as any[]),(null as any),(null as any),(null as any),View_InputTextComponent_0,
      RenderType_InputTextComponent)),i1.ɵdid(638976,(null as any),0,i4.InputTextComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const InputTextComponentNgFactory:i1.ComponentFactory<i4.InputTextComponent> = i1.ɵccf('inline-edit-input-text',
    i4.InputTextComponent,View_InputTextComponent_Host_0,{data:'data',fingerprint:'fingerprint',
        placeholder:'placeholder',clear:'clear',required:'required'},{onSave:'onSave',
        onCancel:'onCancel'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./compiled/src/app/components/shared/inline-edit/components/input-text/input-text.component.ngfactory.ts